// import { useRef, useState } from 'react';
// import {  DISPLAY_DIMENSIONS, CROP_REGION } from './constants';

// // it s redundant, ill remove it later
// interface CropRegion {
//   width: number;
//   height: number;
//   x: number;
//   y: number;
// }

// interface VideoProcessingResult {
//   videoStream: MediaStream | null;
//   videoRef: React.RefObject<HTMLVideoElement>;
//   processingCanvasRef: React.RefObject<HTMLCanvasElement>;
//   processedStreamRef: React.RefObject<MediaStream | null>;
//   isVideoLoading: boolean;
//   deviceId?: string;
//   createCroppedStream: (
//     inputStream: MediaStream,
//     cropRegion: CropRegion
//   ) => MediaStream | null;
//   startVideoStream: (deviceId: string, optionValue: string) => Promise<void>;
//   stopVideoStream: () => void;
//   setIsVideoLoading: React.Dispatch<React.SetStateAction<boolean>>;
//   getVideoStream: () => Promise<MediaStream | null>;
//   setVideoStream :React.Dispatch<React.SetStateAction<MediaStream | null>>;
// }

// export const useVideoProcessing = (deviceId = ''): VideoProcessingResult => {
//   console.log('deviceId:::::', deviceId);
//   const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
//   const [isVideoLoading, setIsVideoLoading] = useState(false);
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const processingCanvasRef = useRef<HTMLCanvasElement>(null);
//   const processedStreamRef = useRef<MediaStream | null>(null);

//   const createCroppedStream = (
//     inputStream: MediaStream,
//     cropRegion: typeof CROP_REGION
//   ): MediaStream | null => {
//     const processingCanvas = processingCanvasRef.current;
//     if (!processingCanvas) return null;
//     console.log("cropRegion ::",cropRegion)
//     const ctx = processingCanvas.getContext('2d');
//     if (!ctx) return null;

//     // Set canvas dimensions to match crop region
//     processingCanvas.width = cropRegion.width;
//     processingCanvas.height = cropRegion.height;

//     // Create a video element to receive the input stream
//     const videoElement = document.createElement('video');
//     videoElement.srcObject = inputStream;
//     videoElement.autoplay = true;

//     // Create output stream from canvas
//     const outputStream = processingCanvas.captureStream();

//     // Process frames
//     const processFrame = () => {
//       if (!videoElement.paused && !videoElement.ended) {
//         ctx.drawImage(
//           videoElement,
//           cropRegion.x,
//           cropRegion.y,
//           cropRegion.width,
//           cropRegion.height,
//           0,
//           0,
//           cropRegion.width,
//           cropRegion.height
//         );
//         requestAnimationFrame(processFrame);
//       }
//     };

//     videoElement.addEventListener('play', () => {
//       processFrame();
//     });

//     return outputStream;
//   };
//   const startVideoStream = async (deviceId: string, optionValue: string) => {
//     // Stop existing tracks before creating new stream
//     let stream: MediaStream | null = null;
//     console.log('startVideoStream :::::', videoStream,deviceId,optionValue);
//     if (videoStream) {
//       videoStream.getTracks().forEach((track) => track.stop());
//     }

//     try {
//       setIsVideoLoading(true);
//       // let stream: MediaStream;
//       console.log('optionValue:', optionValue);
//       if (optionValue === 'Share') {
//         stream = await navigator.mediaDevices.getDisplayMedia({
//           video: true,
//           audio: false,
//         });
//       } else if (optionValue === 'USB') {
//         stream = await navigator.mediaDevices.getUserMedia({
//           video: {
//             deviceId: { exact: deviceId },
//           },
//           audio: false,
//         });
//       } else {
//         throw new Error('Invalid option value');
//       }

//       if (videoRef.current) {
//         console.log('test aaa', stream);
//         videoRef.current.srcObject = stream;
//         setVideoStream(stream);

//         // Auto-play the video
//         const playPromise = videoRef.current.play();
//         if (playPromise !== undefined) {
//           playPromise.catch((error) => {
//             console.error('Error playing video:', error);
//           });
//         }
//       }
//     } catch (error) {
//       console.error('Error accessing the video stream: ', error);
//     } finally {
//       setIsVideoLoading(false);
//     }
//   };

//   const stopVideoStream = () => {
//     console.log('ask,oa:', videoStream);
//     if (videoStream) {
//       videoStream.getTracks().forEach((track) => track.stop());
//       setVideoStream(null);
//     }

//     if (processedStreamRef.current) {
//       processedStreamRef.current.getTracks().forEach((track) => track.stop());
//       processedStreamRef.current = null;
//     }
//   };

//   const getVideoStream = async (
//     deviceId: string,
//     optionValue: string
//   ): Promise<MediaStream> => {
//     const constraints = {
//       video: {
//         deviceId: deviceId,
//       },
//     };

//     switch (optionValue) {
//       case 'Share':
//         return await navigator.mediaDevices.getDisplayMedia(constraints);
//       case 'USB':
//         return await navigator.mediaDevices.getUserMedia(constraints);
//       default:
//         throw new Error(`Unsupported video source: ${optionValue}`);
//     }
//   };

//   return {
//     videoStream,
//     videoRef,
//     processingCanvasRef,
//     processedStreamRef,
//     isVideoLoading,
//     setIsVideoLoading,
//     createCroppedStream,
//     startVideoStream,
//     stopVideoStream,
//     getVideoStream,
//     setVideoStream
//   };
// };
import { useRef, useState, useCallback, useEffect } from 'react';
import { DISPLAY_DIMENSIONS, CROP_REGION } from './constants';

interface CropRegion {
  width: number;
  height: number;
  x: number;
  y: number;
}

interface VideoQualityMetrics {
  actualWidth: number;
  actualHeight: number;
  frameRate: number;
  codec: string;
  resolutionMismatch: boolean;
}

interface VideoProcessingResult {
  videoStream: MediaStream | null;
  videoRef: React.RefObject<HTMLVideoElement>;
  processingCanvasRef: React.RefObject<HTMLCanvasElement>;
  processedStreamRef: React.RefObject<MediaStream | null>;
  isVideoLoading: boolean;
  deviceId?: string;
  createCroppedStream: (
    inputStream: MediaStream,
    cropRegion: CropRegion
  ) => MediaStream | null;
  startVideoStream: (deviceId: string, optionValue: string) => Promise<void>;
  stopVideoStream: () => void;
  setIsVideoLoading: React.Dispatch<React.SetStateAction<boolean>>;
  getVideoStream: () => Promise<MediaStream | null>;
  setVideoStream: React.Dispatch<React.SetStateAction<MediaStream | null>>;
  getVideoQualityMetrics: () => VideoQualityMetrics | null;
  videoQualityMetrics: VideoQualityMetrics | null;
  canvasWidth: number;
  canvasHeight: number;
  updateCanvasSize: (width: number, height: number) => void;
}

// HIGH QUALITY CONSTRAINTS FOR DIFFERENT SOURCES
const VIDEO_QUALITY_PRESETS = {
  USB_CAPTURE_CARD: {
    video: {
      width: { ideal: 1920, min: 1280 },
      height: { ideal: 1080, min: 720 },
      frameRate: { ideal: 30, min: 24 },
      aspectRatio: { ideal: 16 / 9 },
    },
    audio: false,
  },
  USB_CAMERA: {
    video: {
      width: { ideal: 1280, min: 640 },
      height: { ideal: 720, min: 480 },
      frameRate: { ideal: 30, min: 15 },
      aspectRatio: { ideal: 16 / 9 },
    },
    audio: false,
  },
  SCREEN_SHARE: {
    video: {
      cursor: 'always' as const,
      displaySurface: 'monitor' as const,
      frameRate: { ideal: 30 },
    },
    audio: false,
  },
  SCREEN_SHARE_MINIMAL: {
    video: {
      cursor: 'always' as const,
    },
    audio: false,
  },
};

export const useVideoProcessing = (deviceId = ''): VideoProcessingResult => {
  console.log('🎥 useVideoProcessing initialized with deviceId:', deviceId);
  
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [videoQualityMetrics, setVideoQualityMetrics] = useState<VideoQualityMetrics | null>(null);
  
  // Dynamic canvas sizing
  const [canvasWidth, setCanvasWidth] = useState(1920);
  const [canvasHeight, setCanvasHeight] = useState(1080);
  
  const videoRef = useRef<HTMLVideoElement>(null);
  const processingCanvasRef = useRef<HTMLCanvasElement>(null);
  const processedStreamRef = useRef<MediaStream | null>(null);

  // Update canvas size dynamically
  const updateCanvasSize = useCallback((width: number, height: number) => {
    console.log(`📐 Updating canvas size: ${width}×${height}`);
    
    setCanvasWidth(width);
    setCanvasHeight(height);

    // Update processing canvas immediately
    if (processingCanvasRef.current) {
      processingCanvasRef.current.width = width;
      processingCanvasRef.current.height = height;
      console.log(`✅ Processing canvas updated to ${width}×${height}`);
    }
  }, []);

  // Monitor video quality and resolution
  const getVideoQualityMetrics = useCallback((): VideoQualityMetrics | null => {
    if (!videoRef.current) return null;

    const video = videoRef.current;
    const { videoWidth, videoHeight } = video;
    
    if (videoWidth === 0 || videoHeight === 0) {
      return null;
    }

    try {
      // Get actual settings from video track
      const tracks = videoStream?.getVideoTracks();
      if (!tracks || tracks.length === 0) return null;

      const settings = tracks[0].getSettings?.();
      if (!settings) {
        return {
          actualWidth: videoWidth,
          actualHeight: videoHeight,
          frameRate: 0,
          codec: 'unknown',
          resolutionMismatch: false,
        };
      }

      const metrics: VideoQualityMetrics = {
        actualWidth: settings.width ?? videoWidth,
        actualHeight: settings.height ?? videoHeight,
        frameRate: settings.frameRate ?? 0,
        codec: getVideoCodec(videoStream),
        resolutionMismatch: false,
      };

      console.log('📊 Video Quality Metrics:', metrics);
      setVideoQualityMetrics(metrics);
      
      // Update canvas to match actual video resolution
      if (videoWidth !== canvasWidth || videoHeight !== canvasHeight) {
        console.log(`🔄 Video resolution changed from ${canvasWidth}×${canvasHeight} to ${videoWidth}×${videoHeight}`);
        updateCanvasSize(videoWidth, videoHeight);
      }

      return metrics;
    } catch (error) {
      console.warn('⚠️ Error getting video metrics:', error);
      return null;
    }
  }, [videoStream, canvasWidth, canvasHeight, updateCanvasSize]);

  // Extract codec from stream
  const getVideoCodec = (stream: MediaStream | null): string => {
    if (!stream) return 'unknown';
    
    try {
      const track = stream.getVideoTracks()[0];
      if (!track) return 'unknown';
      
      const capabilities = (track as any).getCapabilities?.();
      if (capabilities?.mimeType) {
        return capabilities.mimeType;
      }
      
      const settings = track.getSettings?.();
      return settings?.mimeType ?? 'unknown';
    } catch {
      return 'unknown';
    }
  };

  // Enhanced canvas cropping with dynamic sizing
  const createCroppedStream = useCallback(
    (inputStream: MediaStream, cropRegion: CropRegion): MediaStream | null => {
      const processingCanvas = processingCanvasRef.current;
      if (!processingCanvas) {
        console.error('❌ Processing canvas not found');
        return null;
      }

      const ctx = processingCanvas.getContext('2d', {
        alpha: true,
        willReadFrequently: false,
      });

      if (!ctx) {
        console.error('❌ Canvas context not available');
        return null;
      }

      // Create a high-quality video element for input
      const videoElement = document.createElement('video');
      videoElement.srcObject = inputStream;
      videoElement.autoplay = true;
      videoElement.playsInline = true;
      videoElement.muted = true;
      videoElement.style.visibility = 'hidden';
      videoElement.style.position = 'absolute';
      videoElement.style.pointerEvents = 'none';
      videoElement.style.width = '0';
      videoElement.style.height = '0';
      videoElement.style.overflow = 'hidden';
      
      // Append to DOM
      document.body.appendChild(videoElement);

      console.log('🎬 Creating cropped stream with region:', cropRegion);

      // Set canvas to crop region dimensions
      processingCanvas.width = cropRegion.width;
      processingCanvas.height = cropRegion.height;
      
      console.log(`📐 Processing canvas set to crop size: ${cropRegion.width}×${cropRegion.height}`);

      // Enable image smoothing for better quality
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      // Create output stream from canvas
      const outputStream = processingCanvas.captureStream(30); // 30 FPS

      let animationFrameId: number | null = null;
      let isProcessing = true;

      const processFrame = () => {
        if (isProcessing && videoElement && !videoElement.paused && !videoElement.ended) {
          try {
            // Clear canvas
            ctx.clearRect(0, 0, processingCanvas.width, processingCanvas.height);

            // Draw the cropped region
            ctx.drawImage(
              videoElement,
              cropRegion.x,
              cropRegion.y,
              cropRegion.width,
              cropRegion.height,
              0,
              0,
              processingCanvas.width,
              processingCanvas.height
            );

            animationFrameId = requestAnimationFrame(processFrame);
          } catch (error) {
            console.error('❌ Error processing frame:', error);
          }
        }
      };

      // Start processing when video is ready
      const handleCanPlay = () => {
        console.log('✅ Video ready, starting frame processing');
        processFrame();
      };

      const handleEnded = () => {
        console.log('⏹️ Video ended, stopping frame processing');
        isProcessing = false;
        if (animationFrameId !== null) {
          cancelAnimationFrame(animationFrameId);
        }
        document.body.removeChild(videoElement);
      };

      videoElement.addEventListener('canplay', handleCanPlay, { once: true });
      videoElement.addEventListener('ended', handleEnded);

      processedStreamRef.current = outputStream;

      return new Proxy(outputStream, {
        get: (target, prop) => {
          if (prop === 'getTracks') {
            return () => target.getTracks();
          }
          return (target as any)[prop];
        },
      }) as MediaStream;
    },
    []
  );

  // Detect device type and request appropriate constraints
  const getConstraintsForDevice = async (
    deviceId: string
  ): Promise<MediaStreamConstraints> => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const device = devices.find((d) => d.deviceId === deviceId);

      if (!device) {
        console.warn('⚠️ Device not found, using USB_CAPTURE_CARD defaults');
        return VIDEO_QUALITY_PRESETS.USB_CAPTURE_CARD;
      }

      const label = device.label.toLowerCase();
      console.log('🔍 Device label:', label);

      if (
        label.includes('capture') ||
        label.includes('hdmi') ||
        label.includes('video') ||
        label.includes('avermedia') ||
        label.includes('elgato') ||
        label.includes('magewell') ||
        label.includes('blackmagic')
      ) {
        console.log('📺 Detected capture card - using high quality constraints');
        return VIDEO_QUALITY_PRESETS.USB_CAPTURE_CARD;
      }

      console.log('📷 Detected USB camera - using camera constraints');
      return VIDEO_QUALITY_PRESETS.USB_CAMERA;
    } catch (error) {
      console.error('❌ Error detecting device:', error);
      return VIDEO_QUALITY_PRESETS.USB_CAPTURE_CARD;
    }
  };

  const startVideoStream = async (deviceId: string, optionValue: string) => {
    console.log('🚀 Starting video stream:', { deviceId, optionValue });

    if (videoStream) {
      console.log('⏹️ Stopping existing video stream');
      videoStream.getTracks().forEach((track) => track.stop());
    }

    try {
      setIsVideoLoading(true);
      let stream: MediaStream | null = null;

      if (optionValue === 'Share') {
        console.log('🖥️ Requesting screen share');
        
        try {
          console.log('📋 Using SCREEN_SHARE constraints');
          stream = await navigator.mediaDevices.getDisplayMedia(
            VIDEO_QUALITY_PRESETS.SCREEN_SHARE as any
          );
          console.log('✅ Screen share acquired with standard constraints');
        } catch (displayMediaError) {
          console.warn(
            '⚠️ Standard screen share constraints failed, trying minimal constraints',
            displayMediaError
          );

          try {
            stream = await navigator.mediaDevices.getDisplayMedia(
              VIDEO_QUALITY_PRESETS.SCREEN_SHARE_MINIMAL as any
            );
            console.log('✅ Screen share acquired with minimal constraints');
          } catch (minimalError) {
            console.error('❌ Both screen share attempts failed:', minimalError);
            throw minimalError;
          }
        }
      } else if (optionValue === 'USB') {
        console.log('🔌 Requesting USB device stream with quality constraints');

        const constraints = await getConstraintsForDevice(deviceId);
        console.log('📋 Using constraints:', constraints);

        const userMediaConstraints: MediaStreamConstraints = {
          ...constraints,
          video: {
            ...(constraints.video as any),
            deviceId: { exact: deviceId },
          },
        };

        try {
          stream = await navigator.mediaDevices.getUserMedia(
            userMediaConstraints
          );
          console.log('✅ Stream acquired with constraints');
        } catch (constraintError) {
          console.warn(
            '⚠️ Exact constraints failed, falling back to ideal constraints',
            constraintError
          );

          const fallbackConstraints = {
            ...constraints,
            video: {
              ...(constraints.video as any),
              deviceId: deviceId,
            },
          };

          stream = await navigator.mediaDevices.getUserMedia(
            fallbackConstraints
          );
        }
      } else {
        throw new Error('Invalid option value: ' + optionValue);
      }

      if (!stream) {
        throw new Error('No stream returned from getUserMedia/getDisplayMedia');
      }

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setVideoStream(stream);

        // Handle metadata loaded to set canvas size dynamically
        const handleLoadedMetadata = () => {
          const video = videoRef.current;
          if (!video) return;

          console.log('📐 Video metadata loaded:', {
            videoWidth: video.videoWidth,
            videoHeight: video.videoHeight,
          });

          // Update canvas to match actual video resolution
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            console.log(`🔄 Updating canvas to match video: ${video.videoWidth}×${video.videoHeight}`);
            updateCanvasSize(video.videoWidth, video.videoHeight);
          }

          // Get quality metrics
          setTimeout(() => getVideoQualityMetrics(), 100);
        };

        videoRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);

        // Auto-play the video
        const playPromise = videoRef.current.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('✅ Video playing successfully');
              setTimeout(() => getVideoQualityMetrics(), 500);
            })
            .catch((error) => {
              console.error('❌ Error playing video:', error);
            });
        }
      }
    } catch (error) {
      console.error('❌ Error accessing video stream:', error);
      setVideoStream(null);
      throw error;
    } finally {
      setIsVideoLoading(false);
    }
  };

  const stopVideoStream = () => {
    console.log('⏹️ Stopping all video streams');

    if (videoStream) {
      videoStream.getTracks().forEach((track) => {
        console.log('❌ Stopping track:', track.label);
        track.stop();
      });
      setVideoStream(null);
    }

    if (processedStreamRef.current) {
      processedStreamRef.current.getTracks().forEach((track) => {
        console.log('❌ Stopping processed track:', track.label);
        track.stop();
      });
      processedStreamRef.current = null;
    }
  };

  const getVideoStream = async (
    deviceId: string,
    optionValue: string
  ): Promise<MediaStream> => {
    if (optionValue === 'Share') {
      try {
        return await navigator.mediaDevices.getDisplayMedia(
          VIDEO_QUALITY_PRESETS.SCREEN_SHARE as any
        );
      } catch {
        return await navigator.mediaDevices.getDisplayMedia(
          VIDEO_QUALITY_PRESETS.SCREEN_SHARE_MINIMAL as any
        );
      }
    } else if (optionValue === 'USB') {
      const constraints = await getConstraintsForDevice(deviceId);
      return await navigator.mediaDevices.getUserMedia({
        ...constraints,
        video: {
          ...(constraints.video as any),
          deviceId: { exact: deviceId },
        },
      });
    }
    throw new Error(`Unsupported video source: ${optionValue}`);
  };

  return {
    videoStream,
    videoRef,
    processingCanvasRef,
    processedStreamRef,
    isVideoLoading,
    setIsVideoLoading,
    createCroppedStream,
    startVideoStream,
    stopVideoStream,
    getVideoStream,
    setVideoStream,
    getVideoQualityMetrics,
    videoQualityMetrics,
    canvasWidth,
    canvasHeight,
    updateCanvasSize,
  };
};